<template>
  <div class="main-con el-main">
    <router-view />
  </div>
</template>

<script>
    export default {
        name: "FinancingRepayment"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/FinancingRepayment.vue